<div *ngIf="meeting && meeting!.location && center">
  <div class="text-neutral-500 mb-4 mt-2">Interview Location</div>
    <google-map
      height="331px"
      width="100%"
      [center]="center"
      [zoom]="zoom">
      <map-marker
        [position]="center"
      ></map-marker>
    </google-map>
</div>
